// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"651":"7172f4d7","808":"9fb24683","968":"52b188c9"}[chunkId] + ".chunk.js";
};